
<template>
    <div class="slider-area banner-style-2 bg-image d-flex align-items-center banner-img" style="opacity: 0.5;">
        <div class="container">
            <div class="row g-5 align-items-center">
                <div class="col-lg-8 col-md-12 content-text-banner">
                    <div class="inner">
                        <div class="content">
                            <span class="pre-title" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">MEJOR
                                FUTURO DE APRENDIZAJE CON NOSOTROS</span>
                            <h1 class="title text-white texto-maquina" data-sal-delay="200" data-sal="slide-up"
                                data-sal-duration="800">{{ Institucion.institucion_nombre }}</h1>
                            <p class="description" data-sal-delay="250" data-sal="slide-up" data-sal-duration="800"
                                v-html="Institucion.institucion_objetivos" style="color: white !important;">
                            </p>
                            <div class="read-more-btn" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">
                                <a class="edu-btn" href="#novedades">Ver novedades <i
                                        class="icon-arrow-right-line-right"></i></a>
                            </div>
                            <!-- <div class="arrow-sign d-lg-block d-none">
                                <img src="@/assets//images/banner/banner-02/arrow.png" alt="Banner Images"
                                    data-sal-delay="150" data-sal="fade" data-sal-duration="800">
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-5">
                    <div class="banner-thumbnail">
                        <img class="girl-thumb" src="@/assets//images/banner/banner-02/banner-01.png" alt="Girl Images"
                            data-sal-delay="150" data-sal="fade" data-sal-duration="800" />
                    </div>
                    <div class="banner-bg d-lg-block d-none">
                        <img class="girl-bg" src="@/assets//images/banner/banner-02/girl-bg.png" alt="Girl Background"
                            data-sal-delay="150" data-sal="fade" data-sal-duration="800" />
                    </div>
                </div> -->
            </div>

        </div>
    </div>

    <div class="sercice-area eduvibe-service-five service-wrapper-5 edu-section-gap bg-color-white">

        <div class="container eduvibe-animated-shape">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        <span class="pre-title">Categorías</span>
                        <h3 class="title">Explorar contenido</h3>
                    </div>
                </div>
            </div>

            <div class="row g-5 mt--25">

                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800"
                    v-for="(conv, id_conv) of MenuConv" :key="id_conv" :class="{ 'sal-animate': isSal }">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Class"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><a href="#" :to="'/convocatorias/' + conv.idtipo_conv_comun"
                                        @click="$store.commit('clickLink')">{{ conv.tipo_conv_comun_titulo }}</a></h6>
                                <p class="description">{{ contarConv(conv.tipo_conv_comun_titulo) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" :class="{ 'sal-animate': isSal }" data-sal-delay="150"
                    data-sal="slide-up" data-sal-duration="800" v-for="(cur, id_cur) of   MenuCur  " :key="id_cur">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Pencil"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link :to="'/cursos/' + cur.idtipo_curso_otros"
                                        @click="$store.commit('clickLink')">{{ cur.tipo_conv_curso_nombre }}</router-link>
                                </h6>
                                <p class="description">{{ contarCur(cur.tipo_conv_curso_nombre) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Pencil"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/servicios">SERVICIOS</router-link></h6>
                                <p class="description"> {{ Serv.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Class"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/ofertas">OFERTAS ACADÉMICAS</router-link></h6>
                                <p class="description">{{ Ofer.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Setting"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/publicaciones">PUBLICACIONES</router-link></h6>
                                <p class="description">{{ Publi.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Mind"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/gaceta">GACETA</router-link></h6>
                                <p class="description">{{ Gac.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Headphone"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/eventos">EVENTOS</router-link></h6>
                                <p class="description">{{ Event.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                    <div class="service-card service-card-5">
                        <div class="inner">
                            <div class="icon">
                                <i class="icon-Microscope"></i>
                            </div>
                            <div class="content">
                                <h6 class="title"><router-link to="/videos">VIDEOS</router-link></h6>
                                <p class="description">{{ Vid.length }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <!-- <div class="shape-image shape-image-1">
                    <img src="assets/images/shapes/shape-19-02.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-2">
                    <img src="assets/images/shapes/shape-21.png" alt="Shape Thumb" />
                </div> -->
            </div>
        </div>
    </div>
    <div class="eduvibe-about-three-mission edu-mission-vision-area edu-section-gap border-bottom-1 bg-color-white"
        style="padding-top: 0 !important;">
        <div class="container eduvibe-animated-shape">
            <div class="row">
                <div class="col-lg-12">

                    <div class="thumbnail mb--50">
                        <div class="shape-image image-1">
                            <img src="@/assets/civil/img-2.jpg" data-parallax='{"x": 0, "y": 80}' alt="Gallery Images"
                                width="700">
                        </div>
                        <div class="shape-image image-2">
                            <img src="@/assets/civil/img-1.jpg" data-parallax='{"x": 0, "y": -60}' alt="Gallery Images">
                        </div>
                        <div class="shape-image image-3">
                            <img src="@/assets/civil/img-4.jpg" data-parallax='{"x": 0, "y": 80}' alt="Gallery Images">
                        </div>
                        <div class="shape-image image-4">
                            <img src="@/assets/civil/img-3.jpg" data-parallax='{"x": 0, "y": -80}' alt="Gallery Images"
                                width="400">
                        </div>
                    </div>
                </div>
            </div>

            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <div class="animated-image shape-image-1">
                    <img src="assets/images/shapes/shape-04-01.png" alt="Shape Thumb" />
                </div>
                <div class="shape shape-1"><span class="shape-dot"></span></div>
                <div class="shape shape-2"><span class="shape-dot"></span></div>
            </div>
        </div>

        <div class="container">
            <div class="row g-5">
                <div class="col-lg-6">
                    <div class="our-mission">
                        <div class="section-title text-start" data-sal-delay="150" data-sal="slide-up"
                            data-sal-duration="800">
                            <span class="pre-title">NUESTRA MISIÓN</span>
                            <h3 class="title">La misión detrás de
                                nuestra <br> carrera</h3>
                            <p v-html="Institucion.institucion_mision" class="mt--30 mb--0"></p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="our-vision">
                        <div class="section-title text-start" data-sal-delay="150" data-sal="slide-up"
                            data-sal-duration="800">
                            <span class="pre-title">NUESTRA VISIÓN
                            </span>
                            <h3 class="title">La vision de nuestra <br> carrera</h3>
                            <p v-html="Institucion.institucion_vision" class="mt--30 mb--0"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="edu-about-area about-style-3 edu-section-gap bg-image image-fondo" :style="{
        'background-image':
            'url(' +
            require('@/assets/civil/img-5.jpg') +
            ')',
    }">
        <div class="container eduvibe-animated-shape">
            <div class="row g-5 align-items-center">

                <div class="col-lg-6 pr--80">
                    <div class="gappery-wrapper" data-sal-delay="200" data-sal="fade" data-sal-duration="800">
                        <div class="row g-5 align-items-end">
                            <div class="col-lg-5 col-md-6">
                                <div class="gallery-image mt--85">
                                    <img class="w-200" src="@/assets/civil/img-4.jpg" alt="Gallery Images">
                                    <div class="icon-badge">
                                        <i class="icon-ribbon"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-7 col-md-6">
                                <div class="gallery-image">
                                    <img class="w-100" src="@/assets/civil/img-2.jpg" alt="Gallery Images">
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <div class="gallery-image gallery-image-3 text-center">
                                    <img src="@/assets/civil/img-1.jpg" alt="Gallery Images">
                                    <div class="student-like-status bounce-slide">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="inner">
                        <div class="section-title text-start" data-sal-delay="200" data-sal="slide-up"
                            data-sal-duration="800">
                            <span class="pre-title">Historia</span>
                            <h3 class="title text-white">Historia De Nuestra Carrera</h3>

                        </div>
                        <p class="description mt--40 text-white" data-sal-delay="200" data-sal="slide-up"
                            data-sal-duration="800" v-html="Institucion.institucion_historia"></p>
                    </div>
                </div>
            </div>
            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <div class="shape-image shape-image-1">
                    <img src="assets/images/shapes/shape-21.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-2">
                    <img src="assets/images/shapes/shape-13-04.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-3">
                    <img src="assets/images/shapes/shape-03-05.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-4">
                    <img src="assets/images/shapes/shape-15-02.png" alt="Shape Thumb" />
                </div>
            </div>

        </div>
    </div>
    <div class="edu-course-area eduvibe-home-two-course course-three-wrapper edu-section-gap bg-color-white">
        <div class="container eduvibe-animated-shape">
            <div class="row g-5">
                <div class="col-lg-12">
                    <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        <span class="pre-title">Convocatoria</span>
                        <h3 class="title">{{ Institucion.institucion_nombre }}</h3>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-10 offset-lg-1">
                    <div class="video-gallery-wrapper edu-section-gapTop video-section-overlayto-another"
                        style="padding-top: 0 !important;">
                        <div class="video-gallery-1">
                            <div class="thumbnail video-popup-wrapper">
                                <iframe :src="Institucion.institucion_link_video_vision" frameborder="0"
                                    style="width: 100%; min-height: 400px" allowfullscreen="allowfullscreen"></iframe>
                                <!-- <a href="#"
                                    class="video-play-btn with-animation position-to-top video-popup-activation btn-secondary-color size-80">
                                    <span class="play-icon"></span>
                                </a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <div class="shape-image shape-image-1">
                    <img src="@/assets//images/shapes/shape-04-02.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-2">
                    <img src="@/assets//images/shapes/shape-03-06.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-3">
                    <img src="@/assets//images/shapes/shape-04-03.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-4">
                    <img src="@/assets//images/shapes/shape-07-01.png" alt="Shape Thumb" />
                </div>
            </div>
        </div>
    </div>

    <div class="edu-event-area eduvibe-home-two-event edu-section-gap bg-image video-gallery-overlay-area"
        style="padding: 200px 0 0 0 !important">
    </div>
    <div class="edu-elements-area edu-section-gap bg-color-white" style="margin-top: 8em;">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-12">
                    <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        <span class="pre-title">Autoridades</span>
                        <h3 class="title">Nuestras autoridades</h3>
                    </div>
                </div>
            </div>
            <div class="row row--20 justify-content-center">

                <div class="col-lg-3 col-md-6 col-sm-6 col-12 mt--45" data-sal-delay="150" data-sal="slide-up"
                    :class="{ 'sal-animate': isSal }" data-sal-duration="800"
                    v-for="(  autoridad, id_aut  ) of   Institucion.autoridad  " :key="id_aut">
                    <div class="edu-instructor-grid edu-instructor-1 edu-instructor-1">
                        <div class="edu-instructor">
                            <div class="inner">
                                <div class="thumbnail">
                                    <a href="instructor-profile.html">
                                        <img :src="url_api +
                                            '/InstitucionUpea/Autoridad/' +
                                            autoridad.foto_autoridad
                                            " alt="img" />
                                    </a>
                                </div>
                                <div class="team-share-info">
                                    <a class="linkedin" :href="'https://wa.me/+' + autoridad.celular_autoridad"
                                        target="_blank"><i class="icon-phone-fill"></i></a>
                                    <a class="facebook" :href="autoridad.facebook_autoridad" target="_blank"><i
                                            class="icon-Fb"></i></a>
                                    <a class="twitter" :href="autoridad.twiter_autoridad" target="_blank"><i
                                            class="icon-Twitter"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="edu-instructor-info">
                            <h5 class="title"><a href="instructor-profile.html">{{ autoridad.nombre_autoridad }}</a></h5>
                            <span class="desc">{{ autoridad.cargo_autoridad }}</span>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="edu-workshop-area eduvibe-home-three-video workshop-style-1 edu-section-gap bg-image bg-color-primary">
        <div class="container eduvibe-animated-shape">
            <div class="row gy-lg-0 gy-5 row--60 align-items-center">
                <div class="col-lg-6 order-2 order-lg-1">
                    <div class="workshop-inner">
                        <div class="section-title text-white" data-sal-delay="150" data-sal="slide-up"
                            data-sal-duration="800">
                            <span class="pre-title">Plan de estudio</span>
                            <h3 class="title">Plan de estudio de nuestra carrera</h3>
                        </div>
                        <!-- <p class="description" data-sal-delay="250" data-sal="slide-up" data-sal-duration="800">Lorem ipsum
                            dolor sit amet, consectetur adipiscing elit. Sit amet, consect adipi scing elit, sed do eiusmod
                            tempor incididunt ut sed do eiusmod tempor incididunt ut labore et dolore aliqua.</p> -->
                        <div class="read-more-btn" data-sal-delay="350" data-sal="slide-up" data-sal-duration="800">
                            <a class="edu-btn btn-white" :href="url_api +
                                '/InstitucionUpea/' +
                                Institucion.institucion_organigrama
                                " target="_blank">Ver plan de estudio<i class="icon-arrow-right-line-right"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 order-1 order-lg-2">
                    <div class="thumbnail video-popup-wrapper">
                        <!-- <img class="radius-small w-100" src="assets/images/videopopup/video-popup-bg-02.jpg"
                            alt="About Image"> -->
                        <a :href="url_api +
                            '/InstitucionUpea/' +
                            Institucion.institucion_organigrama
                            " target="_blank">
                            <!-- <vue-pdf-embed :source="url_api +
                                '/InstitucionUpea/' +
                                Institucion.institucion_organigrama
                                " /> -->
                            <!-- <iframe src="https://webquery.ujmd.edu.sv/siab/bvirtual/Fulltext/ADAM0000618/C1.pdf"
                                width="100%" height="600" frameborder="1" scrolling="yes">
                            </iframe> -->
                            <vue-pdf-embed :source="url_api +
                                '/InstitucionUpea/' +
                                Institucion.institucion_organigrama
                                " :page="1" height="410" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <div class="shape-image shape-image-1">
                    <img src="assets/images/shapes/shape-09-01.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-2">
                    <img src="assets/images/shapes/shape-04-05.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-3">
                    <img src="assets/images/shapes/shape-13-02.png" alt="Shape Thumb" />
                </div>
            </div>

        </div>
    </div>
    <div class="eduvibe-about-three-team edu-team-area edu-section-gap bg-color-white">
        <div class="container eduvibe-animated-shape">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        <span class="pre-title">Nuestra institución</span>
                        <h3 class="title">Conoce a nuestra carrera</h3>
                    </div>
                </div>
            </div>
            <div class="row g-5 mt--20">
                <!-- Start Instructor Grid  -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12" data-sal-delay="150" data-sal="slide-up"
                    data-sal-duration="800">
                    <div class="edu-instructor-grid edu-instructor-3 edu-instructor-3-visible">
                        <div class="edu-instructor">
                            <div class="inner">
                                <div class="thumbnail">
                                    <a href="#">
                                        <img :src="url_api +
                                            '/InstitucionUpea/' +
                                            Institucion.institucion_logo
                                            " alt="Logo image">
                                    </a>
                                </div>
                                <div class="edu-instructor-info">
                                    <h5 class="title"><a href="instructor-profile.html">James Carlson</a></h5>
                                    <span class="desc">UI Designer</span>
                                    <div class="team-share-info bg-transparent">
                                        <a class="linkedin" href="#"><i class="icon-linkedin"></i></a>
                                        <a class="facebook" href="#"><i class="icon-Fb"></i></a>
                                        <a class="twitter" href="#"><i class="icon-Twitter"></i></a>
                                        <a class="youtube" href="#"><i class="icon-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- End Instructor Grid  -->

                <!-- Start Instructor Grid  -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12" data-sal-delay="200" data-sal="slide-up"
                    data-sal-duration="800">
                    <div class="edu-instructor-grid edu-instructor-3 edu-instructor-3-visible">
                        <div class="edu-instructor">
                            <div class="inner">
                                <div class="thumbnail">
                                    <a href="#">
                                        <img src="@/assets/sie.png" alt="Sie logo">
                                    </a>
                                </div>
                                <div class="edu-instructor-info">
                                    <h5 class="title"><a href="instructor-profile.html">Nancy Phipps</a></h5>
                                    <span class="desc">UI Designer</span>
                                    <div class="team-share-info bg-transparent">
                                        <a class="linkedin" href="#"><i class="icon-linkedin"></i></a>
                                        <a class="facebook" href="#"><i class="icon-Fb"></i></a>
                                        <a class="twitter" href="#"><i class="icon-Twitter"></i></a>
                                        <a class="youtube" href="#"><i class="icon-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- End Instructor Grid  -->

                <!-- Start Instructor Grid  -->
                <div class="col-lg-4 col-md-6 col-sm-6 col-12" data-sal-delay="250" data-sal="slide-up"
                    data-sal-duration="800">
                    <div class="edu-instructor-grid edu-instructor-3 edu-instructor-3-visible">
                        <div class="edu-instructor">
                            <div class="inner">
                                <div class="thumbnail">
                                    <a href="#">
                                        <img src="@/assets/upea.png" alt="Upea logo">
                                    </a>
                                </div>
                                <div class="edu-instructor-info">
                                    <h5 class="title"><a href="instructor-profile.html">Troy Hall</a></h5>
                                    <span class="desc">UI Designer</span>
                                    <div class="team-share-info bg-transparent">
                                        <a class="linkedin" href="#"><i class="icon-linkedin"></i></a>
                                        <a class="facebook" href="#"><i class="icon-Fb"></i></a>
                                        <a class="twitter" href="#"><i class="icon-Twitter"></i></a>
                                        <a class="youtube" href="#"><i class="icon-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- End Instructor Grid  -->

            </div>
            <div class="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                <div class="shape-image shape-image-1">
                    <img src="assets/images/shapes/shape-04-01.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-2">
                    <img src="assets/images/shapes/shape-25-01.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-3">
                    <img src="assets/images/shapes/shape-03.png" alt="Shape Thumb" />
                </div>
                <div class="shape-image shape-image-4">
                    <img src="assets/images/shapes/shape-15-05.png" alt="Shape Thumb" />
                </div>
            </div>
        </div>
    </div>
    <div class="edu-elements-area edu-section-gap bg-color-white" id="novedades">
        <div class="container">
            <div class="row g-5">
                <div class="col-lg-12">
                    <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        <span class="pre-title">Lo mas reciente</span>
                        <h3 class="title">Eventos recientes de nuestra carrera</h3>
                    </div>
                </div>
            </div>
            <div class="row g-5 mt--10">
                <div class="col-lg-12">
                    <div class="row g-5 justify-content-center">
                        <div class="col-lg-4 col-md-6 col-12" :class="{ 'sal-animate': isSal }" data-sal="slide-up"
                            data-sal-delay="150" data-sal-duration="800" data-sal-easing="ease-out-bounce"
                            v-if="Object.keys(latestConv).length != 0">
                            <div class="edu-blog blog-type-2 radius-small">
                                <div class="inner">
                                    <div class="thumbnail">
                                        <router-link :to="'/detalleConvocatoria/' + latestConv.idconvocatorias"
                                            @click="$store.commit('clickLink')">
                                            <img :src="url_api + '/Convocatorias/' + latestConv.con_foto_portada"
                                                alt="img" />
                                        </router-link>
                                    </div>
                                    <div class="content">
                                        <div class="status-group">
                                            <a href="#" class="eduvibe-status status-05"><i
                                                    class="icon-price-tag-3-line"></i> {{
                                                        latestConv.tipo_conv_comun.tipo_conv_comun_titulo }}</a>
                                        </div>
                                        <h5 class="title">
                                            <router-link :to="'/detalleConvocatoria/' + latestConv.idconvocatorias"
                                                @click="$store.commit('clickLink')">
                                                {{ latestConv.con_titulo }}
                                            </router-link>

                                        </h5>
                                        <div class="blog-card-bottom">
                                            <ul class="blog-meta">
                                                <li>
                                                    <i class="icon-calendar-2-line"></i>{{ dmy(latestConv.con_fecha_inicio)
                                                    }}
                                                </li>
                                            </ul>
                                            <div class="read-more-btn">
                                                <router-link class="btn-transparent"
                                                    :to="'/detalleConvocatoria/' + latestConv.idconvocatorias"
                                                    @click="$store.commit('clickLink')">
                                                    Leer mas<i class="icon-arrow-right-line-right"></i>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-12" :class="{ 'sal-animate': isSal }" data-sal="slide-up"
                            data-sal-delay="150" data-sal-duration="800" data-sal-easing="ease-out-bounce"
                            v-if="Object.keys(latestComun).length != 0">
                            <div class="edu-blog blog-type-2 radius-small">
                                <div class="inner">
                                    <div class="thumbnail">
                                        <router-link :to="'/detalleConvocatoria/' + latestComun.idconvocatorias"
                                            @click="$store.commit('clickLink')">
                                            <img :src="url_api + '/Convocatorias/' + latestComun.con_foto_portada"
                                                alt="img" />
                                        </router-link>
                                    </div>
                                    <div class="content">
                                        <div class="status-group">
                                            <a href="#" class="eduvibe-status status-05"><i
                                                    class="icon-price-tag-3-line"></i> {{
                                                        latestComun.tipo_conv_comun.tipo_conv_comun_titulo }}</a>
                                        </div>
                                        <h5 class="title">
                                            <router-link :to="'/detalleConvocatoria/' + latestComun.idconvocatorias"
                                                @click="$store.commit('clickLink')">
                                                {{ latestComun.con_titulo }}
                                            </router-link>

                                        </h5>
                                        <div class="blog-card-bottom">
                                            <ul class="blog-meta">
                                                <li>
                                                    <i class="icon-calendar-2-line"></i>{{ dmy(latestComun.con_fecha_inicio)
                                                    }}
                                                </li>
                                            </ul>
                                            <div class="read-more-btn">
                                                <router-link class="btn-transparent"
                                                    :to="'/detalleConvocatoria/' + latestComun.idconvocatorias"
                                                    @click="$store.commit('clickLink')">
                                                    Leer mas<i class="icon-arrow-right-line-right"></i>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="edu-contact-map-area edu-section-gapBottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row g-5">
                        <div class="col-lg-12">
                            <div class="section-title text-center" data-sal-delay="150" data-sal="slide-up"
                                data-sal-duration="800">
                                <span class="pre-title">Nuestra Ubicación 4</span>
                                <h3 class="title">{{ Institucion.institucion_direccion }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="google-map alignwide" data-sal="slide-up" data-sal-delay="150" data-sal-duration="800">
                        <iframe class="radius-small" :src="Institucion.institucion_api_google_map" width="85%" height="400"
                            frameborder="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.vue-pdf-embed>div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.banner-img {
    background-image: url("@/assets/Fondo2.jpg");
}

.texto-maquina {
    overflow: hidden;
    white-space: nowrap;
    border-right: 2px solid #e3e3e3;
    /* Simula el cursor de escritura */
    animation: maquina-escribir 4s steps(30) infinite;
}

.content-text-banner {
    background-color: #1a191966;
    padding: 4rem;
    border-radius: 15px;
}

.description>p {
    /* Estilos para los elementos p anidados dentro de .description */
    /* Puedes agregar aquí tus estilos personalizados */
    font-size: 16px;
    color: red;
    /* Otros estilos */
}

.image-fondo::after {
    content: "";
    background-color: rgba(0, 0, 0, 0.5);
    /* Cambia el color y la opacidad según tus preferencias */
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.banner-img {
    background-image: url("@/assets/Fondo2.jpg");
}

@keyframes maquina-escribir {
    0% {
        width: 0;
    }

    100% {
        width: 100%;
    }
}
</style>
<script>
import { mapState } from "vuex";
import VuePdfEmbed from "vue-pdf-embed";
import sal from 'sal.js';
export default {
    name: "HomeView",
    data() {
        return {
            isSal: true,
            Conv: 0,
            latestConv: {},
            latestComun: {},
            latestAv: {},

            Cur: 0,
            latestCur: {},
            latestSem: {},

            Serv: [],
            Ofer: [],
            Publi: [],
            Gac: [],
            Event: [],
            Vid: [],

            NUM_RESULTS: 3,
            pag: 1,
            pager: 0,
        };
    },
    computed: {
        ...mapState(["url_api", "Institucion", "MenuConv", "MenuCur", "Links", "getter"]),
    },
    components: {
        VuePdfEmbed,
    },
    methods: {
        async getConvocatoriasAll() {
            try {
                let res = await this.axios.get(
                    "/api/convocatoriasAll/" + process.env.VUE_APP_ID_CARRERA
                );
                this.Conv = res.data;
                console.log(this.Conv);
                this.Conv.forEach((conv) => {
                    if (
                        conv.tipo_conv_comun.tipo_conv_comun_titulo == "CONVOCATORIAS" &&
                        conv.con_estado == "1"
                    ) {
                        if (Object.keys(this.latestConv).length == 0) {
                            this.latestConv = conv;
                        }
                    } else {
                        if (
                            conv.tipo_conv_comun.tipo_conv_comun_titulo == "COMUNICADOS" &&
                            conv.con_estado == "1"
                        ) {
                            if (Object.keys(this.latestComun).length == 0) {
                                this.latestComun = conv;
                            }
                        } else {
                            if (
                                conv.tipo_conv_comun.tipo_conv_comun_titulo == "AVISOS" &&
                                conv.con_estado == "1"
                            ) {
                                if (Object.keys(this.latestAv).length == 0) {
                                    this.latestAv = conv;
                                }
                            }
                        }
                    }
                });
                this.pager = this.Institucion.autoridad.length / this.NUM_RESULTS;
                if (this.pager - Math.trunc(this.pager) > 0) {
                    this.pager = Math.trunc(this.pager) + 1;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async getCursosAll() {
            try {
                let res = await this.axios.get(
                    "/api/cursosAll/" + process.env.VUE_APP_ID_CARRERA
                );
                this.Cur = res.data;
                this.Cur.forEach((cur) => {
                    if (
                        cur.tipo_curso_otro.tipo_conv_curso_nombre == "CURSOS" &&
                        cur.det_estado == "1"
                    ) {
                        if (Object.keys(this.latestCur).length == 0) {
                            this.latestCur = cur;
                        }
                    } else {
                        if (
                            cur.tipo_curso_otro.tipo_conv_curso_nombre == "SEMINARIOS" &&
                            cur.det_estado == "1"
                        ) {
                            if (Object.keys(this.latestSem).length == 0) {
                                this.latestSem = cur;
                            }
                        }
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        async getServiciosAll() {
            try {
                let res = await this.axios.get(
                    "/api/ServicioAll/" + process.env.VUE_APP_ID_CARRERA
                );
                this.Serv = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getOfertasAll() {
            try {
                let res = await this.axios.get(
                    "/api/OfertasAcademicasAll/" + process.env.VUE_APP_ID_CARRERA
                );
                this.Ofer = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getPublicaciones() {
            try {
                let res = await this.axios.get(
                    "/api/publicacionesAll/" + process.env.VUE_APP_ID_INSTITUCION
                );
                this.Publi = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getGacetaAll() {
            try {
                let res = await this.axios.get(
                    "/api/gacetaunivAll/" + process.env.VUE_APP_ID_INSTITUCION
                );
                this.Gac = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getEventos() {
            try {
                let res = await this.axios.get(
                    "/api/eventoAll/" + process.env.VUE_APP_ID_INSTITUCION
                );
                this.Event = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getVideos() {
            try {
                let res = await this.axios.get(
                    "/api/VideosAll/" + process.env.VUE_APP_ID_INSTITUCION
                );
                this.Vid = res.data;
                // this.$store.commit("loading");
            } catch (error) {
                console.log(error);
            }
        },
        async setImage(id, img) {
            try {
                await document
                    .querySelector("." + id)
                    .setAttribute("style", 'background-image: url("' + img + '");');
            } catch (error) {
                console.log(error);
            }
        },
        contarConv(tipo) {
            if (tipo && this.Conv) {
                let count = 0;
                this.Conv.forEach((conv) => {
                    if (conv.tipo_conv_comun.tipo_conv_comun_titulo == tipo) {
                        count++;
                    }
                });
                return count;
            }
        },
        contarCur(tipo) {
            if (tipo && this.Cur) {
                let count = 0;
                this.Cur.forEach((cur) => {
                    if (cur.tipo_curso_otro.tipo_conv_curso_nombre == tipo) {
                        count++;
                    }
                });
                return count;
            }
        },
        dmy(fecha) {
            if (fecha != undefined) {
                const meses = [
                    "enero",
                    "febrero",
                    "marzo",
                    "abril",
                    "mayo",
                    "junio",
                    "julio",
                    "agosto",
                    "septiembre",
                    "octubre",
                    "noviembre",
                    "diciembre",
                ];
                let fechaCadena = fecha.substr(0, 10);
                let fechaArray = fechaCadena.split("-");
                return (
                    fechaArray[2] +
                    " de " +
                    meses[fechaArray[1] - 1] +
                    " de " +
                    fechaArray[0]
                );
            }
        },
    },
    created() {
        this.$store.commit("loadOn");
        this.getConvocatoriasAll();
        this.getCursosAll();
        this.getServiciosAll();
        this.getOfertasAll();
        this.getPublicaciones();
        this.getGacetaAll();
        this.getEventos();
        this.getVideos();
    },
    mounted() {
        sal()
        setTimeout(() => {
            this.isSal = true;
        }, 150);
    },
    updated() {
        if (this.getter) {
            this.isSal = false;
            setTimeout(() => {
                this.isSal = true;
            }, 150);
            this.$store.commit("loadOn");
            this.$store.state.getter = false;
        }

    },
};
</script>